var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-legal",style:(_vm.estilo)},[_vm._v(" Desarrollado por "),_c('a',{attrs:{"href":"https://megapos.co","target":"_blank"}},[_vm._v("megapos.co")])])
}
var staticRenderFns = []

export { render, staticRenderFns }